import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImagineHead: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImagineHead"><Path d="M15.1335 22L15.8802 19.0357C16.7252 15.8421 22.5611 18.9211 19.9084 11.2237L21.5 9.17105C20.029 8.42673 18.0348 7.87843 17.4764 6.20473C16.7536 4.03804 15.1335 2.5 10.8892 2.5M6.64487 22L7.17537 19.4342C7.67616 16.5279 3.92233 14.0788 3.5 11.2237" stroke="currentColor"/><Path d="M6.35 2.5H5.65L4.775 4.775L2.5 5.65V6.35L4.775 7.225L5.65 9.5H6.35L7.225 7.225L9.5 6.35V5.65L7.225 4.775L6.35 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconImagineHead;
